import { createStyles } from "@mantine/emotion";

export const useStylesBorderedContent = createStyles((theme) => ({
  borderedContent: {
    marginTop: theme.spacing.borderedContent.marginTop,
    maxWidth: theme.spacing.borderedContent.maxWidth,
    position: "relative",
    marginLeft: "auto",
    marginRight: "auto",
    width: "100%",

    [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
      maxWidth: theme.spacing.borderedContent.maxWidthMobile,
      marginLeft: theme.spacing.borderedContent.marginXMobile,
      marginRight: theme.spacing.borderedContent.marginXMobile,
    },

    ".borders": {
      inset: "0",
      margin: "auto",
      position: "relative",
      paddingBottom: theme.spacing.borderedContent.padding.bottom,
      paddingTop: theme.spacing.borderedContent.padding.top,
      paddingLeft: theme.spacing.borderedContent.padding.sides,
      paddingRight: theme.spacing.borderedContent.padding.sides,

      backgroundImage: `
        radial-gradient(
          ${theme.spacing.borderedContent.borderDotSize},
          transparent 98%,
          white
        ),
        linear-gradient(white 0 0)
      `,
      backgroundRepeat: "round, no-repeat",
      backgroundPosition: `
        calc(${theme.spacing.borderedContent.borderDotSize} * -1.5) calc(${theme.spacing.borderedContent.borderDotSize} * -1.5),
        50%
      `,
      backgroundSize: `
        calc(${theme.spacing.borderedContent.borderDotSize} * 3) calc(${theme.spacing.borderedContent.borderDotSize} * 3),
        calc(100% - ${theme.spacing.borderedContent.borderDotSize} * 3) calc(100% - ${theme.spacing.borderedContent.borderDotSize} * 3)
      `,
      zIndex: 10,
      width: "100%",
    },
    ".borders-no": {
      paddingBottom: theme.spacing.borderedContentNot.padding.bottom,
      paddingTop: theme.spacing.borderedContentNot.padding.top,
    },

    ".shadow": {
      content: "''",
      display: "block",
      position: "absolute",
      left: theme.spacing.borderedContent.shadowOffset,
      top: theme.spacing.borderedContent.shadowOffset,
      width: `calc(100% - calc(${theme.spacing.borderedContent.shadowOffset} * 2))`,
      height: `calc(100% - calc(${theme.spacing.borderedContent.shadowOffset} * 2))`,
      boxShadow: `0 0 ${theme.spacing.borderedContent.shadowBlur} rgba(0, 0, 0, 0.45)`,
      zIndex: 1,
      border: 0,
    },

    ".details": {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      backgroundColor: theme.customBackgrounds.white,
      maxWidth: "100%",

      ".tooltip": {
        position: "absolute",
        right: theme.spacing.borderedContent.tooltipOffset.right,
        top: theme.spacing.borderedContent.tooltipOffset.top,
      },
    },

    ".info": {
      marginTop: "1em",
      marginBottom: "1em",
      [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
        display: "block",
      },

      ".mantine-Flex-root": {
        [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
          display: "block",
        },
      },

      ".key": {
        fontSize: theme.spacing.borderedContent.keyFontSize,
        fontFamily: theme.headings.fontFamily.light,
        color: theme.customColors.blackLight,
        lineHeight: "1.8em",
        minWidth: "9em",

        [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
          display: "block",
        },
      },

      ".value": {
        fontSize: theme.spacing.borderedContent.valueFontSize,
        fontFamily: theme.headings.fontFamily.medium,
        color: theme.customColors.black,

        [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
          display: "block",
        },

        img: {
          width: "1.5em",
          height: "1.5em",
        },

        p: {
          fontSize: theme.spacing.borderedContent.innerFontSize,
        },

        span: {
          fontSize: theme.spacing.borderedContent.innerFontSize,
          fontFamily: theme.headings.fontFamily.light,
          color: theme.customColors.blackLight,
        },

        ".stamp-change-flag": {
          color: theme.customColors.blackLight,
          fontFamily: theme.headings.fontFamily.primary,
          fontSize: theme.spacing.borderedContent.changeFlag.valueFontSize,
        },
      },

      ".value-timestamps": {
        fontFamily: theme.headings.fontFamily.bold,
      },

      ".stamp-link": {
        textDecoration: "none",
        "&:hover": {
          textDecoration: "underline",
        },
      },

      ".stamp-user-value-group": {
        display: "flex",
        marginBottom: theme.spacing.borderedContent.userValue.marginBottom,
        minWidth: "0",
        rowGap: theme.spacing.borderedContent.userValue.rowGap,

        [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
          display: "flex",
          flexWrap: "wrap",
        },

        ".stamp-user": {
          lineHeight: theme.spacing.borderedContent.userValue.lineHeight,
          overflowWrap: "break-word",
        },
      },

      ".stamp-change-flag": {
        alignItems: "center",
        color: theme.customColors.blackLight,
        display: "inline-flex",
        fontFamily: theme.headings.fontFamily.primary,
        fontSize: theme.spacing.borderedContent.changeFlag.fontSize,
        lineHeight: theme.spacing.borderedContent.changeFlag.lineHeight,
        paddingLeft: theme.spacing.borderedContent.changeFlag.paddingLeft,

        [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
          lineHeight: theme.spacing.borderedContent.changeFlag.lineHeightMobile,
          paddingLeft:
            theme.spacing.borderedContent.changeFlag.paddingLeftMobile,
        },

        ".stamp-change-flag-dot": {
          bottom: theme.spacing.borderedContent.changeFlag.dotBottomOffset,
          color: theme.customColors.blackLight,
          fontSize: theme.spacing.borderedContent.changeFlag.dotFontSize,
          lineHeight: theme.spacing.borderedContent.changeFlag.dotLineHeight,
          marginRight: theme.spacing.borderedContent.changeFlag.dotMarginRight,
          position: "relative",
        },
      },
    },

    ".date": {
      borderBottom: theme.customColors.timeStampBorder,
      paddingBottom: theme.spacing.borderedContent.date.paddingBottom,
      marginBottom: theme.spacing.borderedContent.date.marginBottom,

      [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
        flexWrap: "wrap",
      },

      ".title": {
        fontSize: theme.spacing.borderedContent.keyFontSize,
        fontFamily: theme.headings.fontFamily.light,
        color: theme.customColors.blackLight,
        minWidth: "9em",
      },

      ".timestamp": {
        lineHeight: "1.2em",
        fontSize: theme.spacing.borderedContent.valueFontSize,
        fontFamily: theme.headings.fontFamily.medium,
      },

      ".time-delta": {
        borderRadius: theme.spacing.borderedContent.timeDelta.borderRadius,
        fontSize: theme.spacing.borderedContent.timeDelta.fontSize,
        backgroundColor: theme.customBackgrounds.timeAgo,
        padding: theme.spacing.borderedContent.timeDelta.padding,
        whiteSpace: "nowrap",
        marginTop: theme.spacing.borderedContent.timeDelta.marginTop,
        color: theme.customColors.white,
        display: "flex",
        alignItems: "center",
        marginLeft: theme.spacing.borderedContent.timeDelta.marginLeft,
        top: theme.spacing.borderedContent.timeDelta.topOffset,
        position: "relative",

        [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
          marginLeft: "0",
        },
      },
    },
  },
}));
